module.exports = __webpack_public_path__ + "static/media/tired.1559af97.svg";